export const extentions = [
    "OP-01",
    "OP-02",
    "OP-03",
    "OP-04",
    "OP-05",
    "OP-06",
    "OP-07",
    "OP-08",
    "OP-09",
    "OP-10",
    "OP-11",
    "OP-12",
    "OP-13",
    "OP-14",
    "OP-15",
    "OP-16",
    "EB-01",
    "EB-02",
    "EB-04",
    "PRB-01",
    "PRB-02",
    "P"
]

export const decks = [
    "ST-01",
    "ST-02",
    "ST-03",
    "ST-04",
    "ST-05",
    "ST-06",
    "ST-07",
    "ST-08",
    "ST-09",
    "ST-10",
    "ST-11",
    "ST-12",
    "ST-13",
    "ST-14",
    "ST-15",
    "ST-16",
    "ST-17",
    "ST-18",
    "ST-19",
    "ST-20",
    "ST-21",
    "ST-22",
    "ST-23",
    "ST-24",
    "ST-25",
    "ST-26",
    "ST-27",
    "ST-28",
    "ST-29",
    "ST-30",
]

export const extentionsNames = [
    {
        id: "OP01-",
        name: "Romance Dawn",
        image: "op01-romance-dawn.webp"
    }, {
        id: "OP02-",
        name: "Paramount War",
        image: "op02-paramount-war.webp"
    }, {
        id: "OP03-",
        name: "Pillars of Strength",
        image: "op03-pillars-of-strength.webp"
    }, {
        id: "OP04-",
        name: "Kingdoms of Intrigue",
        image: "op04-kingdoms-of-intrigue.webp"
    }, {
        id: "OP05-",
        name: "Awakening of the new Era",
        image: "op05-awakening-of-the-new-era.webp"
    }, {
        id: "OP06-",
        name: "Wings of the Captain",
        image: "op06-wings-of-the-captain.webp"
    }, {
        id: "OP07-",
        name: "500 Years in the Future",
        image: "op07-500-years-in-the-future.webp"
    }, {
        id: "OP08-",
        name: "Two Legends",
        image: "op08-two-legends.webp"
    }, {
        id: "OP09-",
        name: "Emperors in the New World",
        image: "op09-emperors-in-the-new-world.webp"
    }, {
        id: "OP10-",
        name: "Royal Blood",
        image: "op10-royal-blood.webp"
    }, {
        id: "OP11-",
        name: "A Fist of Divine Speed",
        image: "op11-a-fist-of-divine-speed.webp"
    }, {
        id: "OP12-",
        name: "Legacy of the Master",
        image: "op12-legacy-of-the-master.webp"
    }, {
        id: "OP13-",
        name: "Carrying on his Will",
        image: "op13-carrying-on-his-will.webp"
    }, {
        id: "OP14-",
        name: "The Azure Sea's Seven (OP14)",
        image: "op14-the-azure-sea-s-seven.webp"
    }, {
        id: "OP15-",
        name: "Adventure on Kami's Island (OP15)",
        image: "op15-adventure-on-kami-s-island.webp"
    }, {
        id: "OP16-",
        name: "The Time of Battle",
        image: "op16-the-time-of-battle.webp"
    }, {
        id: "EB01-",
        name: "Extra Booster: Memorial Collection",
        image: "eb01-extra-booster-memorial-collection.webp"
    }, {
        id: "EB02-",
        name: "Extra Booster: Anime 25th Collection",
        image: "eb02-extra-booster-anime-25th-collection.webp"
    },  {
        id: "EB03-",
        name: "Extra Booster: Heroines Edition",
        image: "eb02-extra-booster-anime-25th-collection.webp"
    }, {
        id: "EB04-",
        name: "The Azure Sea's Seven (EB04) + Adventure on Kami's Island (EB04)",
        image: "eb04-the-azure-sea-s-seven-adventure-on-kami-s-island.webp"
    }, {
        id: "PRB01",
        name: "The Best",
        image: "prb01-the-best.webp"
    }, {
        id: "PRB02-",
        name: "The Best Vol.2",
        image: "prb02-the-best-vol-2.webp"
    }, { 
        id: "ST01-", 
        name: "Straw Hat Crew", 
        image: "st01-straw-hat-crew.webp" 
    }, { 
        id: "ST02-", 
        name: "Worst Generation", 
        image: "st02-worst-generation.webp" 
    }, { 
        id: "ST03-", 
        name: "The Seven Warlords of the Sea", 
        image: "st03-the-seven-warlords-of-the-sea.webp" 
    }, { 
        id: "ST04-", 
        name: "Animal Kingdom Pirates", 
        image: "st04-animal-kingdom-pirates.webp" 
    }, { 
        id: "ST05-", 
        name: "ONE PIECE FILM edition", 
        image: "st05-one-piece-film-edition.webp" 
    }, { 
        id: "ST06-", 
        name: "Absolute Justice", 
        image: "st06-absolute-justice.webp" 
    }, { 
        id: "ST07-", 
        name: "Big Mom Pirates",
        image: "st07-big-mom-pirates.webp" 
    }, { 
        id: "ST08-", 
        name: "Monkey.D.Luffy", 
        image: "st08-monkey-d-luffy.webp" 
    }, { 
        id: "ST09-", 
        name: "Yamato", 
        image: "st09-yamato.webp" 
    }, { 
        id: "ST10-", 
        name: "The Three Captains", 
        image: "st10-the-three-captains.webp" 
    }, { 
        id: "ST11-", 
        name: "Uta", 
        image: "st11-uta.webp" 
    }, { 
        id: "ST12-", 
        name: "Zoro & Sanji", 
        image: "st12-zoro-&-sanji.webp" 
    }, { 
        id: "ST13-", 
        name: "The Three Brothers", 
        image: "st13-the-three-brothers.webp" 
    }, { 
        id: "ST14-", 
        name: "3D2Y", 
        image: "st14-3d2y.webp" 
    }, { 
        id: "ST15-", 
        name: "Edward Newgate", 
        image: "st15-edward-newgate.webp" 
    }, { 
        id: "ST16-", 
        name: "Uta", 
        image: "st16-uta.webp" 
    }, { 
        id: "ST17-", 
        name: "Donquixote Doflamingo", 
        image: "st17-donquixote-doflamingo.webp" 
    }, { 
        id: "ST18-", 
        name: "Monkey.D.Luffy", 
        image: "st18-monkey-d-luffy.webp" 
    }, { 
        id: "ST19-", 
        name: "Smoker", 
        image: "st19-smoker.webp" 
    }, { 
        id: "ST20-", 
        name: "Charlotte Katakuri", 
        image: "st20-charlotte-katakuri.webp" 
    }, { 
        id: "ST21-", 
        name: "Gear 5th", 
        image: "st21-gear-5th.webp" 
    }, { 
        id: "ST22-", 
        name: "Ace & Newgate", 
        image: "st22-ace-&-newgate.webp" 
    }, { 
        id: "ST23-", 
        name: "Shanks", 
        image: "st23-shanks.webp" 
    }, { 
        id: "ST24-", 
        name: "Jewelry Bonney", 
        image: "st24-jewelry-bonney.webp" 
    }, { 
        id: "ST25-", 
        name: "Buggy", 
        image: "st25-buggy.webp" 
    }, { 
        id: "ST26-", 
        name: "Monkey.D.Luffy", 
        image: "st26-monkey-d-luffy.webp" 
    }, { 
        id: "ST27-", 
        name: "Marshall.D.Teach", 
        image: "st27-marshall-d-teach.webp" 
    }, { 
        id: "ST28-", 
        name: "Yamato", 
        image: "st28-yamato.webp" 
    }, { 
        id: "ST29-", 
        name: "Egg Head", 
        image: "st29-egg-head.webp" 
    }, { 
        id: "ST30-", 
        name: "Luffy & Ace", 
        image: "st30-luffy-ace.webp" 
    }, { 
        id: "P-", 
        name: "Promotion Cards", 
        image: "p-promotion-cards.webp" 
    }
]